import { message } from 'antd'
import i18n from 'i18next'

export const onSetDefaultForecast = ({ setDefaultForecast, setShowScreenSuccess }) => {
  setDefaultForecast().then(() => {
    setShowScreenSuccess(null)
    message.success(i18n.t('FEEDBACK_SAVE_CHANGES_SUCCES'), 8)
  })
}
